import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Footer from "./Footer";
import Header from "./Header";
import Scroll from "./Scroll";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import CrackersLoader from "./CrackersLoader";
import { FaTrashAlt, FaShoppingCart, FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaCity, FaTag, FaRupeeSign, FaCheck, FaWhatsapp } from "react-icons/fa";
import MobileNavigation from "./MobileNavigation";
import "./cart.css"

// Helper function to round to nearest whole number
const roundToNearestRupee = (amount) => {
  return Math.round(amount);
};

function Cart() {
  const [cartItems, setCartItems] = useState([]);
  const [discountvalue, setDiscountvalue] = useState();
  const [formData, setFormData] = useState({
    firstName: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [minimumOrder, setMinimumOrder] = useState(null);
  const [storeClosed, setStoreClosed] = useState(null);
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 426);

  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [coupondiscount, setCouponDiscount] = useState("");
  const [validCoupons, setValidCoupons] = useState([]);
  const [couponStartDate, setCouponStartDate] = useState(null);
const [couponEndDate, setCouponEndDate] = useState(null);
  

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 426);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("cartItems")) || [];
    setCartItems(items);
  }, []);

  const handleQuantityChange = (product_id, change) => {
    const updatedItems = cartItems.map((item) => {
      if (item.product_id === product_id) {
        const newCount = item.count + change;

        if (newCount < 1) {
          return { ...item, count: 1 };
        }

        if (newCount > item.stock) {
          alert(`Only ${item.stock} item(s) available in stock.`);
          return item;
        }

        return { ...item, count: newCount };
      }
      return item;
    });

    setCartItems(updatedItems);
    localStorage.setItem("cartItems", JSON.stringify(updatedItems));

    const updatedCounts = updatedItems.reduce((acc, item) => {
      acc[item.product_id] = item.count;
      return acc;
    }, {});

    saveCountsToLocalStorage(updatedCounts);
  };

  const handleDelete = (product_id) => {
    const updatedItems = cartItems.filter(
      (item) => item.product_id !== product_id
    );

    localStorage.setItem("cartItems", JSON.stringify(updatedItems));
    setCartItems(updatedItems);
    localStorage.removeItem(`count_${product_id}`);

    const totalUniqueProductCount = updatedItems.length;
    localStorage.setItem("cartCount", totalUniqueProductCount);
    saveCountsToLocalStorage(updatedItems);
  };

  const calculateTotal = (price, count) => {
    if (!price) {
      return "0";
    }

    const sanitizedPrice = parseFloat(price.replace(/[^\d.-]/g, ""));
    if (isNaN(sanitizedPrice)) {
      return "0";
    }

    return roundToNearestRupee(count * sanitizedPrice);
  };

  const getSubtotal = () => {
    return roundToNearestRupee(
      cartItems.reduce((total, item) => {
        return total + parseFloat(calculateTotal(item.oldprice, item.count));
      }, 0)
    );
  };

  const getDiscountedTotal = () => {
    const discountAmount = cartItems.reduce((total, item) => {
      if (item.is_non_discount === "0") {
        const discount = Math.round(discountvalue);
        const itemTotal = parseFloat(calculateTotal(item.oldprice, item.count));
        const discountedItemTotal = (itemTotal * discount) / 100;
        return total + discountedItemTotal;
      } else {
        return total;
      }
    }, 0);

    return roundToNearestRupee(discountAmount);
  };

  const getOrderTotal = () => {
    const subtotal = getSubtotal();
    const discountTotal = getDiscountedTotal();
    return roundToNearestRupee(subtotal - discountTotal);
  };

  const coupondiscountamount = () => {
    const total = getOrderTotal();
    return roundToNearestRupee(total * (coupondiscount / 100));
  };

  const grandTotal = () => {
    let total = getOrderTotal();
    
    // if (isCouponApplied && coupondiscount > 0) {
    //   total = total - total * (coupondiscount / 100);
    // }
      if (isCouponApplied && coupondiscount > 0) {
      total = total - coupondiscountamount();
    }
    
    return roundToNearestRupee(total);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobileNumber" && !/^\d*$/.test(value)) {
      return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "email" && !formData[key]) {
        errors[key] = "This field is required.";
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleOrderSuccess = () => {
    localStorage.removeItem("cartItems");
    localStorage.removeItem("cartCount");
    const productKeys = Object.keys(localStorage).filter((key) =>
      key.startsWith("count_")
    );
    productKeys.forEach((key) => localStorage.removeItem(key));
    window.dispatchEvent(new Event("cartUpdated"));
    navigate("/thanks");
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const loadAllData = async () => {
      try {
        const homeRes = await axios.post(`${API_BASE_URL}home.php`);
        const { body } = homeRes.data;

        if (body) {
          const storeInfo = body.minimum_order_store_closed?.[0];
          if (storeInfo) {
            setMinimumOrder(storeInfo.minimum_order);
            setStoreClosed(storeInfo.store_closed);
          }

          if (typeof body.coupen_code === "string") {
            setValidCoupons(body.coupen_code.split(',').map(code => code.trim().toUpperCase()));
          } else if (Array.isArray(body.coupen_code) && typeof body.coupen_code[0] === "string") {
            setValidCoupons(body.coupen_code[0].split(',').map(code => code.trim().toUpperCase()));
          }
          
          setDiscountvalue(body.discount_value?.[0]?.discount_value || 0);
          setCouponDiscount(body.coupen_percentage || 0);

           // ✅ Add these two lines
        setCouponStartDate(body.start_date || null);
        setCouponEndDate(body.end_date || null);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadAllData();
  }, []);

  const isCouponDateValid = () => {
  if (!couponStartDate || !couponEndDate) return true; // no dates set = always valid
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = new Date(couponStartDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(couponEndDate);
  end.setHours(23, 59, 59, 999);
  return today >= start && today <= end;
};

// Format date for display: "14 Sep 2026"
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

  const handleCouponChange = (e) => {
    setCouponCode(e.target.value.trim().toUpperCase());
    setErrorMessage("");
    setIsCouponApplied(false);
  };

  // const applyCoupon = () => {
  //   if (!couponCode) {
  //     setErrorMessage("Please enter a referral code.");
  //     setIsCouponApplied(false);
  //     return;
  //   }

  //   if (validCoupons.includes(couponCode.toUpperCase())) {
  //     setIsCouponApplied(true);
  //     setErrorMessage("");
  //     // Show success message
  //     alert(`Coupon code "${couponCode}" applied successfully! You get ${coupondiscount}% discount.`);
  //   } else {
  //     setErrorMessage("Invalid referral code. Please enter a valid one.");
  //     setIsCouponApplied(false);
  //   }
  // };
  const applyCoupon = () => {
  if (!couponCode) {
    setErrorMessage("Please enter a referral code.");
    setIsCouponApplied(false);
    return;
  }

  // ✅ Check date validity first
  if (!isCouponDateValid()) {
    const now = new Date();
    const start = new Date(couponStartDate);
    const end = new Date(couponEndDate);

    if (now < start) {
      setErrorMessage(
        `This coupon is not yet active. It will be valid from ${formatDate(couponStartDate)}.`
      );
    } else if (now > end) {
      setErrorMessage(
        `This coupon has expired on ${formatDate(couponEndDate)}.`
      );
    } else {
      setErrorMessage("This coupon is not valid at the moment.");
    }
    setIsCouponApplied(false);
    return;
  }

  if (validCoupons.includes(couponCode.toUpperCase())) {
    setIsCouponApplied(true);
    setErrorMessage("");
    alert(
      `Coupon code "${couponCode}" applied successfully! You get ${coupondiscount}% discount.`
    );
  } else {
    setErrorMessage("Invalid referral code. Please enter a valid one.");
    setIsCouponApplied(false);
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);

      const orderData = {
        name: formData.firstName,
        email: formData.email,
        phonenumber: formData.mobileNumber,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        pincode: formData.pincode,
        subtotal: getSubtotal(),
        discount: getDiscountedTotal(),
        coupon_discount: isCouponApplied ? coupondiscountamount() : 0,
        total: grandTotal(),
        coupen_code: isCouponApplied ? couponCode : "",
        product: cartItems.map((item) => ({
          product_id: item.product_id,
          category_id: item.category_id || "",
          product_name: item.product_name,
          unit_price: item.oldprice,
          quantity: item.count,
          final_price: calculateTotal(item.oldprice, item.count),
        })),
      };

      try {
        const response = await axios.post(`${API_BASE_URL}order.php`, orderData);
        console.log("API Response:", response.data);
        alert("Order placed successfully!");
        handleOrderSuccess();
      } catch (error) {
        console.error("There was an error placing the order!", error);
        alert("Failed to place order. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  const saveCountsToLocalStorage = (data) => {
    if (Array.isArray(data)) {
      data.forEach((item) => {
        localStorage.setItem(`count_${item.product_id}`, item.count);
      });
    } else {
      Object.entries(data).forEach(([product_id, count]) => {
        localStorage.setItem(`count_${product_id}`, count);
      });
    }
    window.dispatchEvent(new Event("storage"));
  };

  if (isLoading) {
    return <CrackersLoader />;
  }

  return (
    <div className="mathi-cart-page">
      <Header />
      
      {/* Cart Header */}
      <div className="cart-header-section">
        <div className="cart-content-wrapper">
          <div className="cart-header-content text-center py-4">
            <FaShoppingCart className="cart-header-icon" />
            <h1 className="cart-title">Your Shopping Cart</h1>
            <p className="cart-subtitle">
              Review your items and proceed to checkout
            </p>
            <div className="cart-items-count">
              <span className="badge bg-primary">{cartItems.length} items</span>
            </div>
          </div>
        </div>
      </div>

      <div className="cart-content-wrapper">
        {/* Cart Items Table */}
        <div className="cart-table-section mb-4">
          <div className="table-responsive">
            <Table className="">
              <thead className="cart-table-head" style={{ "--bs-table-bg": "linear-gradient(135deg, #9622d9, #b31b80)"}}>
                <tr className="cart-table-head" style={{ background: 'linear-gradient(135deg, #9622d9, #b31b80)'}}>
                  <th className="text-center color-white">Image</th>
                  <th className="text-center color-white">Product Name</th>
                  {!isSmallScreen && <th className="text-center color-white">Price</th>}
                  {!isSmallScreen && <th className="text-center color-white">Quantity</th>}
                  <th className="text-center color-white">Total</th>
                  <th className="text-center color-white">Del</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.length === 0 ? (
                  <tr>
                    <td colSpan={isSmallScreen ? 4 : 6} className="text-center py-5">
                      <div className="empty-cart">
                        <FaShoppingCart className="empty-cart-icon" />
                        <h5>Your cart is empty</h5>
                        <p>Add some crackers to get started!</p>
                        <Link to="/" className="btn btn-primary">
                          Continue Shopping
                        </Link>
                      </div>
                    </td>
                  </tr>
                ) : (
                  cartItems.map((item) => {
                    const isNonDiscount = parseInt(item.is_non_discount, 10) === 1;
                    // Round the prices for display
                    const roundedOldPrice = item.oldprice ? roundToNearestRupee(parseFloat(item.oldprice.replace(/[^\d.-]/g, ""))) : 0;
                    const roundedPrice = item.price ? roundToNearestRupee(parseFloat(item.price.replace(/[^\d.-]/g, ""))) : 0;
                    
                    return (
                      <tr key={item.product_id} className="cart-item-row">
                        <td className="cart-item-image">
                          <img
                            src={item.image}
                            alt={item.product_name}
                            loading="lazy"
                            className="img-thumbnail"
                          />
                        </td>
                        <td className="cart-item-details">
                          <h6 className="cart-item-name">{item.product_name}</h6>
                          {isSmallScreen && (
                            <div className="mobile-price-qty">
                              <div className="mobile-price">
                                {isNonDiscount ? (
                                  <span className="current-price">
                                    <i className="bi bi-currency-rupee"></i> {roundedOldPrice}
                                  </span>
                                ) : (
                                  <>
                                    <del className="old-price">
                                      <i className="bi bi-currency-rupee"></i> {roundedOldPrice}
                                    </del>
                                    <span className="current-price">
                                      <i className="bi bi-currency-rupee"></i> {roundedPrice}
                                    </span>
                                  </>
                                )}
                              </div>
                              <div className="mobile-quantity">
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => handleQuantityChange(item.product_id, -1)}
                                >
                                  -
                                </Button>
                                <span className="quantity-display">{item.count}</span>
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => handleQuantityChange(item.product_id, 1)}
                                >
                                  +
                                </Button>
                              </div>
                            </div>
                          )}
                        </td>
                        {!isSmallScreen && (
                          <td className="cart-item-price text-center">
                            {isNonDiscount ? (
                              <span className="current-price">
                                <i className="bi bi-currency-rupee"></i> {roundedOldPrice}
                              </span>
                            ) : (
                              <>
                                <del className="old-price">
                                  <i className="bi bi-currency-rupee"></i> {roundedOldPrice}
                                </del>
                                <br />
                                <span className="current-price">
                                  <i className="bi bi-currency-rupee"></i> {roundedPrice}
                                </span>
                              </>
                            )}
                          </td>
                        )}
                        {!isSmallScreen && (
                          <td className="cart-item-quantity">
                            <div className="quantity-control">
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => handleQuantityChange(item.product_id, -1)}
                              >
                                -
                              </Button>
                              <span className="quantity-number">{item.count}</span>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => handleQuantityChange(item.product_id, 1)}
                              >
                                +
                              </Button>
                            </div>
                          </td>
                        )}
                        <td className="cart-item-total text-center">
                          <span className="item-total">
                            <i className="bi bi-currency-rupee"></i> 
                            {calculateTotal(
                              isNonDiscount ? item.oldprice : item.price,
                              item.count
                            )}
                          </span>
                        </td>
                        <td className="cart-item-action text-center">
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDelete(item.product_id)}
                            title="Remove item"
                            className="delete-button"
                          >
                            <FaTrashAlt />
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Cart Summary and Checkout */}
        <div className="row">
          <div className="col-lg-8">
            <Card className="cart-form-card shadow-sm">
              <Card.Body>
                <div className="form-header mb-4">
                  <div className="form-icon">
                    <FaUser />
                  </div>
                  <h4>Customer Details</h4>
                  <p className="text-muted">Fill in your information to proceed</p>
                </div>

                <Form noValidate onSubmit={handleSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaUser className="me-2" /> Full Name *
                        </label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          placeholder="Enter your full name"
                          value={formData.firstName}
                          onChange={handleChange}
                          isInvalid={!!formErrors.firstName}
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.firstName}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaPhone className="me-2" /> Mobile Number *
                        </label>
                        <Form.Control
                          type="tel"
                          name="mobileNumber"
                          placeholder="Enter 10-digit mobile number"
                          value={formData.mobileNumber}
                          onChange={handleChange}
                          isInvalid={!!formErrors.mobileNumber}
                          maxLength={10}
                          pattern="[0-9]*"
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.mobileNumber}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaEnvelope className="me-2" /> Email Address
                        </label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Enter your email"
                          value={formData.email}
                          onChange={handleChange}
                          isInvalid={!!formErrors.email}
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.email}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaMapMarkerAlt className="me-2" /> Address *
                        </label>
                        <Form.Control
                          as="textarea"
                          name="address"
                          placeholder="Enter your complete address"
                          rows={3}
                          value={formData.address}
                          onChange={handleChange}
                          isInvalid={!!formErrors.address}
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.address}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaCity className="me-2" /> City *
                        </label>
                        <Form.Control
                          type="text"
                          name="city"
                          placeholder="Enter your city"
                          value={formData.city}
                          onChange={handleChange}
                          isInvalid={!!formErrors.city}
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.city}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">State</label>
                        <Form.Control
                          type="text"
                          name="state"
                          placeholder="Enter your state"
                          value={formData.state}
                          onChange={handleChange}
                          className="form-control-lg"
                        />
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">Pincode *</label>
                        <Form.Control
                          type="text"
                          name="pincode"
                          placeholder="Enter 6-digit pincode"
                          value={formData.pincode}
                          onChange={handleChange}
                          isInvalid={!!formErrors.pincode}
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.pincode}
                        </Form.Control.Feedback>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>

          <div className="col-lg-4">
            <Card className="cart-summary-card shadow-sm">
              <Card.Body>
                <div className="summary-header mb-4">
                  <h4>Order Summary</h4>
                  <p className="text-muted">Review your order details</p>
                </div>

                {/* Order Summary */}
                <div className="order-summary mb-4">
                  <h6 className="summary-title">Price Details</h6>
                  <div className="summary-items">
                    <div className="summary-item d-flex justify-content-between">
                      <span>Subtotal</span>
                      <span className="fw-bold">
                        <i className="bi bi-currency-rupee"></i> {getSubtotal()}
                      </span>
                    </div>
                    <div className="summary-item d-flex justify-content-between">
                      <span>Discount ({Math.round(discountvalue)}%)</span>
                      <span className="text-success">
                        -  <i className="bi bi-currency-rupee"></i> {getDiscountedTotal()}
                      </span>
                    </div>
                    <div className="summary-total d-flex justify-content-between mt-3 pt-3 border-top">
                      <span className="fw-bold">Total Amount</span>
                      <span className="fw-bold fs-5 text-primary">
                        <i className="bi bi-currency-rupee"></i> {grandTotal()}
                      </span>
                    </div>
                    {/* Coupon Code Section */}
                    {/* <div className="coupon-section mt-3">
                      <div className="input-group">
                        <Form.Control
                          type="text"
                          placeholder="Enter code"
                          value={couponCode}
                          onChange={handleCouponChange}
                          className="form-control"
                          disabled={isCouponApplied}
                        />
                        <Button
                          variant={isCouponApplied ? "success" : "primary"}
                          onClick={applyCoupon}
                          disabled={isCouponApplied || !couponCode}
                          className="btn-apply-coupon"
                        >
                          {isCouponApplied ? <FaCheck /> : 'Apply'}
                        </Button>
                      </div>
                      <p style={{ color: "red", fontWeight: "bold", fontSize: "13px" }}>Enter Your Referal Number or Coupon Code</p>
                      {errorMessage && (
                        <div className="text-danger small mt-1">{errorMessage}</div>
                      )}
                      {isCouponApplied && coupondiscount > 0 && (
                        <div className="text-success small mt-1">
                          ✅ Coupon applied! {coupondiscount}% discount
                        </div>
                      )}
                    </div> */}
                    {/* Coupon Code Section */}
<div className="coupon-section mt-3">

  {/* Coupon validity banner */}
  {couponStartDate && couponEndDate && (
    <div
      className={`coupon-validity-banner mb-2 ${
        isCouponDateValid() ? "valid" : "invalid"
      }`}
    >
      {isCouponDateValid() ? (
        <>
          <span className="badge bg-success me-2">Active</span>
          <small>
            Offer valid till <strong>{formatDate(couponEndDate)}</strong>
          </small>
        </>
      ) : new Date() < new Date(couponStartDate) ? (
        <>
          <span className="badge bg-warning text-dark me-2">Coming Soon</span>
          <small>
            Offer starts on <strong>{formatDate(couponStartDate)}</strong>
          </small>
        </>
      ) : (
        <>
          <span className="badge bg-danger me-2">Expired</span>
          <small>
            Offer ended on <strong>{formatDate(couponEndDate)}</strong>
          </small>
        </>
      )}
    </div>
  )}

  <div className="input-group">
    <Form.Control
      type="text"
      placeholder="Enter code"
      value={couponCode}
      onChange={handleCouponChange}
      className="form-control"
      disabled={isCouponApplied}
    />
    <Button
      variant={isCouponApplied ? "success" : "primary"}
      onClick={applyCoupon}
      disabled={isCouponApplied || !couponCode}
      className="btn-apply-coupon"
    >
      {isCouponApplied ? <FaCheck /> : "Apply"}
    </Button>
  </div>

  <p style={{ color: "red", fontWeight: "bold", fontSize: "13px" }}>
    Enter Your Referal Number or Coupon Code
  </p>

  {errorMessage && (
    <div className="text-danger small mt-1">{errorMessage}</div>
  )}

  {isCouponApplied && coupondiscount > 0 && (
    <div className="text-success small mt-1">
      ✅ Coupon applied! {coupondiscount}% discount
    </div>
  )}
</div>

                    {isCouponApplied && coupondiscount > 0 && (
                      <div className="summary-item d-flex justify-content-between mt-2">
                        <span>Coupon Discount ({coupondiscount}%)</span>
                        <span className="text-success">
                          - <i className="bi bi-currency-rupee"></i> {coupondiscountamount()}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Minimum Order Check */}
                {storeClosed === "1" ? (
                  <div className="alert alert-danger" role="alert">
                    <h6>Store Closed</h6>
                    <p className="mb-0">Our store is currently closed. Please try again later.</p>
                  </div>
                ) : (
                  <>
                    {grandTotal() < minimumOrder ? (
                      <Link to="/">
                      <div className="alert alert-warning" role="alert">
                        <h6>Minimum Order Required</h6>
                        <p className="mb-0">
                          Minimum order amount is  <i className="bi bi-currency-rupee"></i> {minimumOrder}. 
                          Add  <i className="bi bi-currency-rupee"></i> {(minimumOrder - grandTotal()).toFixed(2)} more to proceed.
                        </p>
                      </div>
                      </Link>
                    ) : (
                      <Button
                        variant="primary"
                        size="lg"
                        className="w-100 mb-3"
                        onClick={handleSubmit}
                        disabled={loading || cartItems.length === 0}
                      >
                        {loading ? (
                          <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Processing...
                          </>
                        ) : (
                          <>
                            <FaWhatsapp className="me-2" />
                            Submit Your Enquiry
                          </>
                        )}
                      </Button>
                    )}
                  </>
                )}

                {/* Cart Info */}
                <div className="cart-info mt-4">
                  <div className="info-item d-flex align-items-center mb-2">
                    <div className="info-icon me-2">
                      <FaShoppingCart />
                    </div>
                    <div className="info-text">
                      <small className="text-muted">
                        {cartItems.length} item(s) in cart
                      </small>
                    </div>
                  </div>
                  <div className="info-item d-flex align-items-center">
                    <div className="info-icon me-2">
                      <FaTag />
                    </div>
                    <div className="info-text">
                      <small className="text-muted">
                        {Math.round(discountvalue)}% discount applied on eligible items
                      </small>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>

      <MobileNavigation />
      <Scroll />
    </div>
  );
}

export default Cart;